var map = {
	"./sample_1.jpg": 9254,
	"./sample_10.jpg": 9500,
	"./sample_11.jpg": 3641,
	"./sample_12.jpg": 2142,
	"./sample_13.jpg": 2299,
	"./sample_14.jpg": 7416,
	"./sample_2.jpg": 8833,
	"./sample_3.jpg": 788,
	"./sample_4.jpg": 8751,
	"./sample_5.jpg": 818,
	"./sample_6.jpg": 717,
	"./sample_7.jpg": 5136,
	"./sample_8.jpg": 603,
	"./sample_9.jpg": 5822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3950;